require('./accessibility.js');
require('./animation.js');
require('./footer.js');
require('./lang.js');
require('./navigation.js');
require('./filter.js');
require('./select2.js');
require('./location.js');
require('./faqs.js');
require('./sliders.js');
require('./mobile.js');
require('./modal.js');
require('./dealers.js');
require('./debouncer.js');
require('./stickyHeader.js');
require('fslightbox');
require('./readmore.js');
require('./switcher.js');
